import find from 'lodash/find';
import intersection from 'lodash/intersection';
import {
  RCS10D,
  RCSANY,
  RCSGT10D,
  RCS$10,
  RCS_LIBRARIES,
  RPS10D,
  RPSANY,
  RPS10D10U,
  RPSANY10U,
  RPS_LIBRARIES,
} from '@Pages/RetroSynthesis/ProjectParametersDialog/constants';

const USED_BUILDING_BLOCKS = 'RX2_PREDICTION_PLAN_LIBRARIES';

export function isRCSAvailable(response) {
  if (!response) return false;
  const optionSet = find(response, (op) => op && op.name === USED_BUILDING_BLOCKS) || {};
  const buildingBlockElements = optionSet.preferences;
  if (!buildingBlockElements) return false;
  return !!find(buildingBlockElements, (item) => RCS_LIBRARIES.includes(item.name));
}

export function isRPSAvailable(response, rpsLibrary = undefined) {
  if (!response) return false;
  const optionSet = find(response, (op) => op && op.name === USED_BUILDING_BLOCKS) || {};
  const buildingBlockElements = optionSet.preferences;
  if (!buildingBlockElements) return false;
  if (rpsLibrary) {
    return !!find(buildingBlockElements, (item) => RPS_LIBRARIES.includes(item.name) && item.name === rpsLibrary);
  }
  return !!find(buildingBlockElements, (item) => RPS_LIBRARIES.includes(item.name));
}

export function isRCSChecked(usedBuildingBlocks) {
  if (!usedBuildingBlocks) return false;
  // eslint-disable-next-line custom/no-unsafe-deep-access
  return intersection(usedBuildingBlocks, RCS_LIBRARIES).length > 0;
}

export function isRPSChecked(usedBuildingBlocks) {
  if (!usedBuildingBlocks) return false;
  // eslint-disable-next-line custom/no-unsafe-deep-access
  return intersection(usedBuildingBlocks, RPS_LIBRARIES).length > 0;
}

// eslint-disable-next-line default-param-last
export function mapUsedRCSToRPSBuildingBlockLibrariesIktos(usedBuildingBlocks = [], rpsChecked, optionsResponse) {
  const nonRPSUsedBuildingBlocks = usedBuildingBlocks.filter((bb) => !RPS_LIBRARIES.includes(bb));

  if (!rpsChecked) {
    return nonRPSUsedBuildingBlocks;
  }

  const _RCS10D = usedBuildingBlocks.includes(RCS10D) ? 1 : 0;
  const _RCSANY = usedBuildingBlocks.includes(RCSANY) ? 1 : 0;

  // Lookup table for mapping RCS to RPS
  const key = `${_RCS10D}${_RCSANY}`;
  /* eslint-disable prettier/prettier */
  const table = {
    '10': RPS10D,
    '01': RPSANY,
  };
  /* eslint-enable prettier/prettier */

  const rpsLibrary = table[key];
  if (rpsLibrary && isRPSAvailable(optionsResponse, rpsLibrary)) {
    return [...nonRPSUsedBuildingBlocks, rpsLibrary];
  }
  return nonRPSUsedBuildingBlocks;
}

// eslint-disable-next-line default-param-last
export function mapUsedRCSToRPSBuildingBlockLibrariesPai(usedBuildingBlocks = [], rpsChecked, optionsResponse) {
  const nonRPSUsedBuildingBlocks = usedBuildingBlocks.filter((bb) => !RPS_LIBRARIES.includes(bb));

  if (!rpsChecked) {
    return nonRPSUsedBuildingBlocks;
  }

  const _RCS10D = usedBuildingBlocks.includes(RCS10D) ? 1 : 0;
  const _RCSGT10D = usedBuildingBlocks.includes(RCSGT10D) ? 1 : 0;
  const _RCS$10 = usedBuildingBlocks.includes(RCS$10) ? 1 : 0;

  // Lookup table for mapping RCS to RPS
  const key = `${_RCS10D}${_RCSGT10D}${_RCS$10}`;
  /* eslint-disable prettier/prettier */
  const table = {
    '100': RPS10D,
    '101': RPS10D10U,
    '001': RPSANY10U,
    '110': RPSANY,
    '010': RPSANY,
    '011': RPSANY10U,
    '111': RPSANY10U,
  };
  /* eslint-enable prettier/prettier */

  const rpsLibrary = table[key];
  if (rpsLibrary && isRPSAvailable(optionsResponse, rpsLibrary)) {
    return [...nonRPSUsedBuildingBlocks, rpsLibrary];
  }
  return nonRPSUsedBuildingBlocks;
}
